import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box, Heading } from '@chakra-ui/react';
import AdminDashboard from './AdminDashboard';
import AdminRoute from '../components/AdminRoute';
import ErrorBoundary from '../components/ErrorBoundary';

export default function AdminApp() {
  return (
    <ErrorBoundary>
      <Box p={8}>
        <Heading size="lg" mb={6}>Admin Dashboard</Heading>
        <Routes>
          <Route path="/*" element={
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          } />
        </Routes>
      </Box>
    </ErrorBoundary>
  );
}
